import { apiSlice } from "./apiSlice";
export const changeTrackerCommentSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

          getChangeTrackerComments: builder.query({
            query: ({ changeId, ...params }) => ({
                url: `Change/${changeId}/comments`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["allChangeTrackerComment"],
        }),


        addChangeTrackerComment: builder.mutation({
            query: (body) => ({
                url: `Change/comments`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['allChangeTrackerComment']
        }),
      
        getAttachmentsByComment: builder.query({
            query: (commentId) => ({
                url: `Change/comments/${commentId}/attachments`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),



    }),
});

export const {
    useAddChangeTrackerCommentMutation,
    useGetAttachmentsByCommentQuery,
    useGetChangeTrackerCommentsQuery
} = changeTrackerCommentSlice;
